import { ViewIcon } from '@chakra-ui/icons';
import { Box, Button, Spinner, Stack, Text } from '@chakra-ui/react';
import { useEffect } from 'react';

type CardQuantitativeProps = {
  callContent: string;
  colorTag: string;
  label: string;
  quantitative: number;
  setContent: any;
  isLoadingQuantitative: boolean;
};

export const CardQuantitative = ({
  callContent,
  colorTag,
  label,
  quantitative,
  setContent,
  isLoadingQuantitative
}: CardQuantitativeProps) => {
  return (
    <Stack
      m="30px 0 0 0 !important"
      w="270px"
      h="170px"
      bg="#FFFFFF"
      borderRadius="24px"
      boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
      position="relative"
    >
      <Box
        w="15px"
        h="170px"
        bg={colorTag}
        borderRadius="24px 0 0 24px"
        position="absolute"
      >
        <span style={{ visibility: 'hidden' }}>tag</span>
      </Box>
      <Box
        w="100%"
        h="170px"
        m="0 !important"
        p="20px 15px 20px 30px !important"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Text
          fontWeight="700"
          fontSize="1.25rem"
          lineHeight="1.875rem"
          h="100px"
        >
          {label}
        </Text>
        {callContent === 'accumuled-values' ? (
          <Text
            w="100%"
            textAlign="end"
            fontWeight="700"
            fontSize="2.5rem"
            lineHeight="2.5rem"
            color="#146CFA"
          >
            {!isLoadingQuantitative ? (
              `R$ ${quantitative.toFixed(2).replace('.', ',')}`
            ) : (
              <Spinner
                thickness="3px"
                speed="0.65s"
                emptyColor="#FF5000"
                color="#FFFFFF"
                size="md"
              />
            )}
            {}
          </Text>
        ) : (
          <Text
            w="100%"
            textAlign="end"
            fontWeight="700"
            fontSize="2.5rem"
            lineHeight="2.5rem"
            color={
              callContent === 'midia'
                ? '#006217'
                : callContent === 'unfulfilled-sales'
                ? '#AA2C23'
                : '#DAA520'
            }
          >
            {!isLoadingQuantitative ? (
              quantitative
            ) : (
              <Spinner
                thickness="3px"
                speed="0.65s"
                emptyColor="#FF5000"
                color="#FFFFFF"
                size="md"
              />
            )}
          </Text>
        )}

        <Button
          h="20px"
          bg="transparent"
          m="0 !important"
          p="0 !important"
          display="flex"
          justifyContent="start"
          alignItems="center"
          fontWeight="400"
          fontSize="0.75rem"
          lineHeight="1.25rem"
          color="#828282"
          onClick={() => {
            setContent(callContent);
          }}
          _hover={{}}
          _active={{}}
          _focus={{
            '&:focus': {
              boxShadow: 'none !important'
            }
          }}
        >
          <ViewIcon w="22px" h="15px" />
          Ver detalhes
        </Button>
      </Box>
    </Stack>
  );
};
